module.exports = __webpack_public_path__ + "img/delivery-man.542a9f7d.png";